import { WorkOrder } from '@app/models/order/work-order';
import { ProductionCard } from '@app/models/production/production-card';
import { ProductionCardDyeingCycle } from './production-card-dyeing-cycle';

export enum DyeingMachineStatus {
  StandBy = 'StandBy',
  Running = 'Running',
  AwaitingQA = 'AwaitingQA',
  Unloading = 'Unloading',
}

export interface DyeingMachine {
  id: string;
  assetId: string;
  productionCardReferences: string[];
  currentProductionCardReference: string | null;
  currentProductionCard?: ProductionCard;
  currentDyeingCycle?: ProductionCardDyeingCycle;
  currentWorkOrder?: WorkOrder;
}

export function getDyeingMachineStatus(machine: DyeingMachine): DyeingMachineStatus {
  const cycle = machine?.currentDyeingCycle;

  if (!cycle || !cycle.startTime) {
    return DyeingMachineStatus.StandBy;
  }

  if (cycle.endTime && cycle.removedTime) {
    return DyeingMachineStatus.StandBy;
  }

  if (cycle.endTime && !cycle.removedTime) {
    if (cycle.colorStatusApproval && cycle.colorStatusApproval.approvalDate) {
      return DyeingMachineStatus.Unloading;
    }
    return DyeingMachineStatus.AwaitingQA;
  }

  return DyeingMachineStatus.Running;
}
